// src/app/writing-tools/writing-tools.model.ts
import { IsArray, IsBoolean, IsEnum, IsNotEmpty, IsNumber, IsOptional, IsString, ValidateIf, ValidateNested } from 'class-validator';
import { GPTMessage } from '../../_core/third-party/open-ai/chat-gpt';
import { Type } from 'class-transformer';

export enum WritingTool {
	FixSpellingGrammar = 'fix-spelling-grammar',
	Summarize          = 'summarize',
	Expand             = 'expand',
	Simplify           = 'simplify',
	Complicate         = 'complicate',
	Translate          = 'translate',
	ChangeTone         = 'change-tone',
	Custom             = 'custom'
}

export enum Language {
	English    = 'english',
	Spanish    = 'spanish',
	French     = 'french',
	German     = 'german',
	Italian    = 'italian',
	Portuguese = 'portuguese',
	Dutch      = 'dutch',
	Russian    = 'russian',
	Japanese   = 'japanese',
	Chinese    = 'chinese',
	Korean     = 'korean',
	Arabic     = 'arabic',
	Hindi      = 'hindi',
	Urdu       = 'urdu',
	Persian    = 'persian',
	Turkish    = 'turkish',
	Indonesian = 'indonesian',
	Malay      = 'malay',
	Vietnamese = 'vietnamese',
	Thai       = 'thai',
	Czech      = 'czech',
	Slovak     = 'slovak',
	Romanian   = 'romanian',
	Hungarian  = 'hungarian',
	Serbian    = 'serbian',
	Croatian   = 'croatian'
}

export enum Tone {
	Professional   = 'professional',
	Casual         = 'casual',
	Straightforward= 'straightforward',
	Confident      = 'confident',
	Friendly       = 'friendly'
}

export class WritingToolsDto {
	@IsEnum(WritingTool)
	tool: WritingTool;

	@ValidateIf(o => o.tool === WritingTool.Translate)
	@IsEnum(Language)
	language?: Language;

	@ValidateIf(o => o.tool === WritingTool.ChangeTone)
	@IsEnum(Tone)
	tone?: Tone;

	@ValidateIf(o => o.tool === WritingTool.Custom)
	@IsString()
	prompt?: string;

	@IsString()
	@IsNotEmpty()
	input: string;
}


export class QueryDto {
	@IsArray()
	@ValidateNested({each: true})
	@Type(() => GPTMessage)
	messages: GPTMessage[]

	@IsNumber()
	temperature: number

	@IsString()
	model: string

	@IsBoolean()
	@IsOptional()
	jsonResponse?: boolean
}


export class ImageOptions {
	/**
	 * AI model to use for generation
	 * Supported: 'gpt-image-1', 'gpt-image-1-mini'
	 */
	@IsString()
	@IsOptional()
	model?: string;

	@IsNumber()
	@IsOptional()
	n?: number;

	@IsString()
	@IsOptional()
	@IsEnum(['256x256', '512x512', '1024x1024', '1536x1024', '1024x1536', 'auto'])
	size?: '256x256' | '512x512' | '1024x1024' | '1536x1024' | '1024x1536' | 'auto';

	@IsString()
	@IsOptional()
	@IsEnum(['standard', 'hd', 'low', 'medium', 'high', 'auto'])
	quality?: 'standard' | 'hd' | 'low' | 'medium' | 'high' | 'auto';

	@IsArray()
	@IsOptional()
	referenceImages?: string[]; // Base64-encoded images or URLs
}

export class ImagesQueryDto {
	/**
	 * Text description of the desired image(s)
	 * Maximum length: 32000 characters for gpt-image-1, 4000 for dall-e-3
	 */
	@IsString()
	@IsNotEmpty()
	prompt: string;


	@ValidateNested()
	@IsOptional()
	@Type(() => ImageOptions)
	options?: ImageOptions;
}

